// AdminContext.js
import { createContext, useContext, useState } from "react";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [hasPermission, setHasPermission] = useState(null);
  const [adminName, setAdminName] = useState("");

  return (
    <AdminContext.Provider
      value={{ hasPermission, setHasPermission, adminName, setAdminName }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminData = () => useContext(AdminContext);
